import { API } from "../helpers";
import { SERVER_URL } from "../config";

export function getProgram(authToken, id) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/programs/${id}`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function updateProgram(authToken, id, data) {
  return API.request({
    method: "put",
    url: `${SERVER_URL}/api/v1/partners/programs/${id}`,
    headers: {
      "Content-Type": "multipart/form-data",
      authentication_token: authToken,
    },
    data,
  });
}

export function deleteProgram(authToken, id) {
  return API.request({
    method: "delete",
    url: `${SERVER_URL}/api/v1/partners/programs/${id}`,
    headers: {
      "Content-Type": "multipart/form-data",
      authentication_token: authToken,
    },
  });
}

export function createProgramCopy(authToken, id) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/programs/${id}/copy`,
    headers: {
      "Content-Type": "multipart/form-data",
      authentication_token: authToken,
    },
  });
}

export function createProgramNew(authToken) {
  return API.request({
    method: "post",
    url: `${SERVER_URL}/api/v1/partners/programs/`,
    headers: {
      "Content-Type": "multipart/form-data",
      authentication_token: authToken,
    },
  });
}

export function getProgramsTypes(authToken) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/programs/program_types`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function getProgramsTypeContent(authToken, programType) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/programs/program_types_content?name=${programType}`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function getCurrencies(authToken) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/currencies`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function getBrochures(authToken) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/programs/brochures`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function getDocumentTypes(authToken) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/document_types`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function getBanners(authToken) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/programs/banners`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function getIntakeRounds(authToken) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/programs/rounds`,
    headers: {
      authentication_token: authToken,
    },
  });
}
